/**
 * RFC 4648 Base32 codec.
 * Used for TOTP secret encoding (`otpauth://` URIs).
 */

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

const DECODE_LUT = new Uint8Array(128).fill(0xff);
for (let i = 0; i < ALPHABET.length; i++) {
  DECODE_LUT[ALPHABET.charCodeAt(i)] = i;
}

export function base32Decode(input: string): Uint8Array {
  const s = input.replace(/=+$/, '').toUpperCase().replace(/\s+/g, '');
  let bits = 0;
  let value = 0;
  const out: number[] = [];
  for (let j = 0; j < s.length; j++) {
    const i = DECODE_LUT[s.charCodeAt(j)]!;
    if (i === 0xff) {
      throw new Error(`Invalid base32 character: ${s[j]}`);
    }
    value = (value << 5) | i;
    bits += 5;
    if (bits >= 8) {
      bits -= 8;
      out.push((value >>> bits) & 0xff);
    }
  }
  return new Uint8Array(out);
}

export function base32Encode(bytes: Uint8Array): string {
  let bits = 0;
  let value = 0;
  let out = '';
  for (const b of bytes) {
    value = (value << 8) | b;
    bits += 8;
    while (bits >= 5) {
      bits -= 5;
      out += ALPHABET[(value >>> bits) & 0x1f];
    }
  }
  if (bits > 0) {
    out += ALPHABET[(value << (5 - bits)) & 0x1f];
  }
  return out;
}

export function isValidBase32(s: string): boolean {
  const cleaned = s.replace(/\s+/g, '').replace(/=+$/, '').toUpperCase();
  if (cleaned.length === 0) return false;
  return /^[A-Z2-7]+$/.test(cleaned);
}
